import ReleaseNotes from "./ReleaseNotes/ReleaseNotes";
import InternalOnlyReleaseNotes from "./ReleaseNotes/InternalOnlyNotes";
import classes from "./PreviewFormat.module.css";
import { exportHTML } from "./Helper/export-html-doc";
import { Container, InputLabel, MenuItem, Select, FormControl } from "@mui/material";
import audioDisplayLogo from "../UI/SoundplusLogo/audiodisplay.png";
import rcsCloudLogo from "../UI/SoundplusLogo/rcscloud.png";
import revmaLogo from "../UI/SoundplusLogo/revma.png";
import selectorCloudLogo from "../UI/SoundplusLogo/selectorcloud.png";
import zettaCloudLogo from "../UI/SoundplusLogo/zettacloud.png";
import { MenuProps } from "../Filters/Utils";

const versionDate = localStorage.getItem("fixVersion");
const fixVersionDescription = localStorage.getItem("version-description");
const projectKey = localStorage.getItem("projectKey");
const getProductInfo = (projectKey) => {
  if (projectKey) {
    const products = {
      SC: { productName: "Selector Cloud", logo: selectorCloudLogo },
      ZC: { productName: "ZettaCloud", logo: zettaCloudLogo },
      RC: { productName: "RCS Cloud", logo: rcsCloudLogo },
      SRE: { productName: "SRE" },
      DIR: { productName: "RCS Cloud", logo: rcsCloudLogo },
      LUM: { productName: "Luminate" },
      ZC2: { productName: "ZettaCloud", logo: zettaCloudLogo },
      STAR: { productName: "STAR" },
      SS: { productName: "ZettaCloud", logo: zettaCloudLogo },
      REVMA: { productName: "REVMA", logo: revmaLogo },
      SIA: { productName: "SIA" },
      CMR: { productName: "Florical" },
      AUD: { productName: "AudioDisplay", logo: audioDisplayLogo },
    };
    if (projectKey.includes(",")) {
      const keys = projectKey.split(",");
      return products[keys[0]];
    }
    return products[projectKey];
  }
};

const product = getProductInfo(projectKey);

async function toBase64(url) {
  const blob = await fetch(url).then((r) => r.blob());
  return new Promise((res) => {
    const reader = new FileReader();
    reader.onloadend = () => res(reader.result);
    reader.readAsDataURL(blob);
  });
}

const logoBase64 = product && (await toBase64(product.logo));

const releaseVersions = () => {
  let versionOutput = "";

  if (versionDate.includes(",")) {
    const versions = versionDate.split(",");
    versions.forEach((version) => {
      versionOutput += version.replace("Production", "").trim() + "\r\n";
    });
    return versionOutput;
  }
  return versionDate.replace("Production", "").trim();
};

const PreviewFormat = () => (
  <Container>
    {/* <WordDocBtn btnHandler={() => exportHTML()}>Export to Word Doc</WordDocBtn> */}
    <FormControl variant="outlined" sx={{ m: 1, minWidth: 300 }}>
      <InputLabel id="ExportOptions">Export Options</InputLabel>
      <Select
        label="ExportOptions"
        id="ExportOptions"
        MenuProps={MenuProps}
        onChange={(e) => {
          exportHTML(e.target.value);
        }}
      >
        <MenuItem value={"doc"}>Export to Word Doc</MenuItem>
        <MenuItem value={"html"}>Export to HTML</MenuItem>
      </Select>
    </FormControl>
    <div id="source-preview-format">
      <header className={classes.Header}>
        <div className={classes.iHeartTitleDiv}>
          {product.logo && (
            <center>
              <img src={logoBase64} width="250" alt={`${product.productName} logo`} />
            </center>
          )}

          <h1 className={classes.ProductName} style={{ "text-align": "center" }}>
            {product.productName && product.productName} Product Release Notes
          </h1>
        </div>
        <h2 className={classes.VersionTitle} style={{ "text-align": "center", whiteSpace: "pre-wrap" }}>
          {releaseVersions()}
        </h2>
        <h4>{fixVersionDescription}</h4>
      </header>

      <h2 className={classes.ProdEnhancements_Fixes}>Enhancements</h2>
      {/* Release notes enhancements */}
      <ReleaseNotes type="Enhancement" />
      <ReleaseNotes type="Story" />
      <ReleaseNotes type="Epic" />
      <ReleaseNotes type="Task" />

      <h2 className={classes.ProdEnhancements_Fixes}>Fixes</h2>
      {/* Release notes Fixes */}
      <ReleaseNotes type="Bug" />
      <ReleaseNotes type="Sub-bug" />
      <ReleaseNotes type="Incident" />
      <ReleaseNotes type="Technical Debt" />

      <h2 className={classes.ProdEnhancements_Fixes}>Internal Only Enhancements</h2>
      {/* Internal Only enhancements */}
      <InternalOnlyReleaseNotes type="Enhancement" internalOnly="dev only" />
      <InternalOnlyReleaseNotes type="Story" internalOnly="dev only" />
      <InternalOnlyReleaseNotes type="Epic" internalOnly="dev only" />
      <InternalOnlyReleaseNotes type="Task" internalOnly="dev only" />

      <h2 className={classes.ProdEnhancements_Fixes}>Internal Only Fixes</h2>
      {/* Internal Only Bugs */}
      <InternalOnlyReleaseNotes type="Bug" internalOnly="dev only" />
      <InternalOnlyReleaseNotes type="Sub-bug" internalOnly="dev only" />
      <InternalOnlyReleaseNotes type="Incident" internalOnly="dev only" />
      <InternalOnlyReleaseNotes type="Technical Debt" internalOnly="dev only" />
    </div>
  </Container>
);

export default PreviewFormat;
